import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { logout } from './logout-action';
import leadsSlice from './leads-slice';
import permissionsSlice from './permissions-slice';
import userSlice from './user-slice';
import quickLinksSlice from './quick-links-slice';
import ticketsSlice from './tickets-slice';
import questionnairesSlice from './questionnaires-slice';
import vouchersSlice from './vouchers-slice';
import patientsSlice from './patients-slice';
import ordersSlice from './orders-slice';
import casesSlice from './cases-slice';
import subscriptionsSlice from './subscriptions-slice';
import productsSlice from './products-slice';
import statusesSlice from './statuses-slice';
import allUsersSlice from './all-users-slice';
import teamsSlice from './teams-slice';
import tokensSlice from './tokens-slice';
import trackingsSlice from './trackings-slice';
import templatesSlice from './templates-slice';
import patientUserSlice from './patient-user-slice';
import userDashboardSlice from './user-dashboard-slice';
import notificationsSlice from './notifications-slice';
import supportChatSlice from './support-chat-slice';
import conversationsChatSlice from './support-chat-conversations-slice';
import patientOrdersSlice from './patient-orders-slice';
import patientSubscriptionsSlice from './patient-subscriptions-slice';
import userProfileSlice from './user-profile-slice';
import clientUsersSlice from './client-users-slice';
import filtersSlice from './filters-data-slice';
import gmailSlice from './gmail-slice';
import typesSlice from './types-slice';
import leadDetailsSlice from './lead-details-slice';
import exportsSlice from './exports-slice';
import appointmentsSlice from './appointments-slice';
import followUpSlice from './follow-up-slice';
import rolesSlice from './roles-slice';
import tenantConfigSlice from './tenant-config-slice';
import labWorksSlice from './lab-works-slice';
import UserProductSlice from './user-products-slice';
import couponsSlice from './coupons-slice';
import agentSalesSlice from './agent-sales-slice';
import quizAttemptsSlice from './quiz-attempts-slice';
import userAffiliateProgramSlice from './user-affiliate-program-slice';
import userAgentSalesSlice from './user-agent-sales-slice';
import patientReferralsSlice from './patient-referrals-slice';
import labReviewsSlice from './lab-reviews-slice';
import productVariantsSlice from './product-variants-slice';
import intakeFormSlice from './intake-form-slice';
import supportTemplatesSlice from './support-templates-slice';
import chargesSlice from './charges-slice';
import contactsSlice from './contacts-slice';
import intakesSlice from './intakes-slice';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['permissionsData', 'userData', 'patientUserData', 'tenantConfigData'],
};

const reducers = combineReducers({
  permissionsData: permissionsSlice,
  userData: userSlice,
  patientUserData: patientUserSlice,
  leadsData: leadsSlice,
  patientsData: patientsSlice,
  ordersData: ordersSlice,
  casesData: casesSlice,
  subscriptionsData: subscriptionsSlice,
  productsData: productsSlice,
  ticketsData: ticketsSlice,
  questionnairesData: questionnairesSlice,
  statusesData: statusesSlice,
  vouchersData: vouchersSlice,
  usersData: allUsersSlice,
  teamsData: teamsSlice,
  quickLinksData: quickLinksSlice,
  tokensData: tokensSlice,
  trackingsData: trackingsSlice,
  templatesData: templatesSlice,
  userDashboardData: userDashboardSlice,
  notificationsData: notificationsSlice,
  supportChatData: supportChatSlice,
  supportConversationsData: conversationsChatSlice,
  patientOrdersData: patientOrdersSlice,
  patientSubscriptionsData: patientSubscriptionsSlice,
  userProfileData: userProfileSlice,
  clientUserData: clientUsersSlice,
  filtersData: filtersSlice,
  gmailData: gmailSlice,
  typesData: typesSlice,
  leadDetailsData: leadDetailsSlice,
  exportsData: exportsSlice,
  appointmentsData: appointmentsSlice,
  followUpData: followUpSlice,
  rolesData: rolesSlice,
  tenantConfigData: tenantConfigSlice,
  labWorksData: labWorksSlice,
  userProductsData: UserProductSlice,
  couponsData: couponsSlice,
  agentSalesData: agentSalesSlice,
  quizAttemptsData: quizAttemptsSlice,
  userAffiliateProgramData: userAffiliateProgramSlice,
  userAgentSalesData: userAgentSalesSlice,
  patientReferralsData: patientReferralsSlice,
  labReviewsData: labReviewsSlice,
  productVariantsData: productVariantsSlice,
  intakeFormData: intakeFormSlice,
  supportTemplatesData: supportTemplatesSlice,
  chargesData: chargesSlice,
  contactsData: contactsSlice,
  intakesData: intakesSlice,
});

const modifiedReducers = (state, action) => {
  if (logout.match(action)) {
    return reducers(undefined, action); //clears redux state on logout
  }
  return reducers(state, action);
};

export const persistedReducer = persistReducer(persistConfig, modifiedReducers);
